import { BallTriangle,Circles } from "react-loader-spinner";
import './LoaderSpinner.scss'

const data = [
    {
        Component: Circles,
        props: {
            color: "#ffdf51",
            height: 70,
            width: 70
        },
        name: "Ball Triangle"
    },
    // {
    //   Component: BallTriangle,
    //   props: {
    //     color: "#0ead69",
    //     radius: 1
    //   },
    //   name: "Ball Triangle"
    // }
];

const LoaderSpinner = () => {
    return (
        <div className="spinner">
            {data.map((loader, index) => (
                <div className="col-xs-12 col-sm-6 col-md-4 col-lg-2 p-5">
                    <div
                        data-tip={loader.name}
                        data-for="happyFace"
                        key={loader.name + index}
                        className="loaderBox"
                    >
                        <loader.Component {...loader.props} />
                    </div>
                </div>
            ))}
        </div>
    )
}


export default LoaderSpinner